import { clients } from '@oncolens/oncolens-ui/lib/api/client';

import { AxiosError } from 'axios';
import { useMutation, UseMutationOptions, useQueryClient } from 'react-query';
import { UserKeys } from '../user.keys';
import { OrgRoleKeys } from './orgrole.keys';

async function deleteOrgRole(id: string) {
  return clients.admin.delete(`/orgroles/${id}`).then(() => {});
}

export function useDeleteOrgRole(options?: UseMutationOptions<void, AxiosError, string>) {
  const queryClient = useQueryClient();

  return useMutation((id: string) => deleteOrgRole(id), {
    onSuccess: () => {
      queryClient.invalidateQueries(UserKeys.all);
      queryClient.invalidateQueries(OrgRoleKeys.all);
    },
    ...options,
  });
}
